import { ADDED_NEW_NODE_EVENT } from '@/consts/analytics.consts';
import { TrackTypeEnum } from '@/hooks/useAnalytics';
import { isModelNode } from '@/components/Nodes/utils/nodeUtils';
import { getModelIdentifier } from '@/utils/nodeInputValidation';
import { track } from '@/utils/analytics';
import { useWorkflowStore } from '@/state/workflow.state';
import type { Node } from '@/types/node';
import type { ModelBaseNodeData } from '@/types/nodes/model';

/** How the node reached the canvas. `add_node` is retained for callers without a specific source. */
export type NodeAddedSource =
  | 'add_node'
  | 'sidebar_drag'
  | 'canvas_context_menu'
  | 'keyboard_shortcut'
  | 'handle_double_click'
  | 'file_drop'
  | 'paste'
  | 'duplicate'
  | 'template_gallery';

/** The model a node runs, or undefined for every non-model node. */
export const nodeModelIdentifier = (node: Node): string | undefined =>
  isModelNode(node) ? (getModelIdentifier(node.data as ModelBaseNodeData) ?? undefined) : undefined;

/** Reports {@link ADDED_NEW_NODE_EVENT} once per node for the paths that add nodes without a menu action. */
export const trackNodesAdded = (nodes: Node[], source: NodeAddedSource) => {
  const workflowId = useWorkflowStore.getState().recipe.id;
  for (const node of nodes) {
    track(
      ADDED_NEW_NODE_EVENT,
      { definitionType: node.type, model: nodeModelIdentifier(node), source, workflowId },
      TrackTypeEnum.BI,
    );
  }
};
